export const USER_TYPE = {
  customer: 1,
  colleague: 2,
  // accountants: 3,
  // saleCounter: 4,
  generalAdmin: 0,
};
export const pageSectionId = {
  homeFirstProduct: { pagecode: 1, boxcode: 1 },
  homeSecondBlog: { pagecode: 1, boxcode: 2 },
  blogFirstBlog: { pagecode: 2, boxcode: 1 },
  blogSecondBlog: { pagecode: 2, boxcode: 2 },
  blogThirdBlog: { pagecode: 2, boxcode: 3 },
  storeFirstProduct: { pagecode: 3, boxcode: 1 },
  storeSecondProduct: { pagecode: 3, boxcode: 2 },
  storeThirdProduct: { pagecode: 3, boxcode: 3 },
  singleProductFirstProduct: { pagecode: 4, boxcode: 1 },
  singleProductSecondProduct: { pagecode: 4, boxcode: 2 },
  singleArticleFirstArticle: { pagecode: 5, boxcode: 1 },
  singleArticleSecondArticle: { pagecode: 5, boxcode: 2 },
};
export const URL_ID = {
  mainPage: { id: 0, name: "خانه", route: "/" },
  shop: { id: 1, name: "فروشگاه", route: "/shop" },
  tours: { id: 2, name: " تور ها", route: "/tours" },
  reserveTour: { id: 3, name: "رزرو تور", route: "/reserve-tour/:id" },
  takTour: { id: 4, name: "تک تور", route: "/tak-tour/:tourId" },
  adminTourList: {
    id: 5,
    name: "لیست تور ها",
    route: "/admin-panel/tour-list",
  },
  attractions: { id: 6, name: "جاذبه ها", route: "/attractions" },
  adminCreateTour: {
    id: 7,
    name: "ساخت تور",
    route: "/admin-panel/create-tour",
  },
  adminUserManagement: {
    id: 8,
    name: "مدیریت کاربران",
    route: "/admin-panel/user-management",
  },
  adminUserReport: {
    id: 9,
    name: "گزارش کاربر",
    route: "/admin-panel/user-report/:edit_key",
  },
  adminManagement: {
    id: 10,
    name: "داشبورد",
    route: "/admin-panel/management",
  },
  adminFinancial: {
    id: 11,
    name: "مدیریت مالی",
    route: "/admin-panel/financial-department",
  },
  adminReservation: {
    id: 12,
    name: "مدیریت رزرو",
    route: "/admin-panel/reservation",
  },
  customerProfile: {
    id: 13,
    name: "پروفایل",
    route: "/customer-panel/profile",
  },
  customerDashboard: {
    id: 14,
    name: "داشبورد",
    route: "/customer-panel/dashboard",
  },
  customerTransactions: {
    id: 15,
    name: "مالی",
    route: "/customer-panel/transactions",
  },
  customerOrders: { id: 16, name: "سفارشات", route: "/customer-panel/orders" },
};
export const baseURL = "http://marketgroup.tatdemo.ir/";
// 09394287564 type 1
